import { render, staticRenderFns } from "./RequestProblemPie.vue?vue&type=template&id=26070d3d&scoped=true"
import script from "./RequestProblemPie.vue?vue&type=script&lang=js"
export * from "./RequestProblemPie.vue?vue&type=script&lang=js"
import style0 from "./RequestProblemPie.vue?vue&type=style&index=0&id=26070d3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26070d3d",
  null
  
)

export default component.exports